import { icons } from 'common'
import styled, { css } from 'styled-components'

const designerCSS = css`
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/lb_bids_stats.css */
  .tier_icon.diamond {
    background: url(${icons.tier_diamond}) center center / 18px auto no-repeat;
    width: 18px;
    height: 18px;
    margin: 0 0 0 5px;
  }
  .tier_icon.diamond.large {
    background: url(${icons.tier_diamond}) center center / 28px auto no-repeat;
    width: 28px;
    height: 28px;
    margin: 0 0 0 5px;
  }
  .tier_icon.gold {
    background: url(${icons.tier_gold}) center center / 18px auto no-repeat;
    width: 18px;
    height: 18px;
    margin: 0 0 0 5px;
  }
  .tier_icon.gold.large {
    background: url(${icons.tier_gold}) center center / 28px auto no-repeat;
    width: 28px;
    height: 28px;
    margin: 0 0 0 5px;
  }
  .tier_icon.silver {
    background: url(${icons.tier_silver}) center center / 18px auto no-repeat;
    width: 18px;
    height: 18px;
    margin: 0 0 0 5px;
  }
  .tier_icon.silver.large {
    background: url(${icons.tier_silver}) center center / 28px auto no-repeat;
    width: 28px;
    height: 28px;
    margin: 0 0 0 5px;
  }
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/referrals.css */
  .referrals_table_wrapper .tier_icon.diamond.large,
  .referrals_table_wrapper .tier_icon.gold.large,
  .referrals_table_wrapper .tier_icon.silver.large {
    margin: 0 5px 0 0;
  }
  .referrals_page_wrapper {
    width: 100%;
    padding: 0 40px;
    min-width: 0;
    margin: 100px 0 0 0;
  }
  .referrals_page_wrapper h1 {
    font-size: 2.5rem;
    font-weight: 300;
    letter-spacing: -0.02em;
  }
  .referrals_page_wrapper h2 {
    font-size: 1rem;
    letter-spacing: -0.01em;
    padding: 10px 0 0 0;
  }
  .referrals_page_wrapper button.get_invite_link {
    font-size: 1.1rem;
    padding: 14px 56px;
    margin: 30px 0 30px 0;
  }

  .referrals_page_wrapper .process {
    padding: 50px 60px 40px 60px;
    margin: 30px 0;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    display: flex;
    align-items: center;
    flex-flow: column;
  }
  .referrals_page_wrapper .process * {
    display: flex;
  }
  .referrals_page_wrapper .process h1 {
    font-size: 1.7rem;
    letter-spacing: -0.02em;
    text-align: center;
    margin: 0 0 40px 0;
    font-weight: 500;
  }
  .referrals_page_wrapper .process .steps {
    width: 100%;
    flex-flow: row;
  }
  .referrals_page_wrapper .process .steps ul {
    width: 33.3%;
    align-items: center;
    flex-flow: column;
  }
  .referrals_page_wrapper .process .steps .step_number {
    font-weight: 700;
    border: 1px solid hsla(221, 73%, 47%, 0.7);
    background: hsla(221, 73%, 47%, 0.2);
    border-radius: 50%;
    margin: 0 0 20px 0;
    width: 80px;
    height: 80px;
  }
  .referrals_page_wrapper .process .steps .step_number.one {
    background: hsla(221, 73%, 47%, 0.2) url(${icons.get_link_icon}) center center / 40px auto no-repeat;
  }
  .referrals_page_wrapper .process .steps .step_number.two {
    background: hsla(221, 73%, 47%, 0.2) url(${icons.invite_friends_icon}) center center / 40px auto no-repeat;
  }
  .referrals_page_wrapper .process .steps .step_number.three {
    background: hsla(221, 73%, 47%, 0.2) url(${icons.start_earning_icon}) center center / 50px auto no-repeat;
  }
  .referrals_page_wrapper .process .steps .step_desc {
    font-size: 1.3rem;
    font-weight: 600;
    text-align: center;
    margin: 0 0 10px 0;
  }
  .referrals_page_wrapper .process .steps .step_desc_add {
    font-size: 0.75rem;
    text-align: center;
    line-height: 130%;
  }
  .referrals_page_wrapper .contest_rules {
    text-align: center;
    opacity: 0.5;
    margin: 60px 0 0 0;
  }
  .referrals_page_wrapper .contest_rules:hover {
    opacity: 1;
  }
  .referrals_page_wrapper .contest_rules p {
    line-height: 150%;
    font-weight: 300;
  }
  .referrals_page_wrapper .contest_rules h2 {
    text-transform: uppercase;
    font-weight: 600;
    text-align: left;
    font-size: 1rem;
    margin: 0 0 10px 0;
  }
  .referrals_page_wrapper .contest_rules ul {
    text-align: left;
  }
  .referrals_page_wrapper .contest_rules ul li {
    text-align: left;
    list-style: disc;
    margin: 5px 0 5px 15px;
    line-height: 160%;
    font-size: 0.75rem;
  }
  .referrals_table_wrapper {
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    position: relative;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    margin: 5px 0 40px 0;
  }
  .referrals_table_wrapper .grid-header {
    display: contents;
  }
  .referrals_table_wrapper .grid-content {
    display: contents;
  }
  .referrals_table_wrapper .yourbids_table_row {
    display: contents;
  }
  .referrals_table_wrapper .yourbids_table_row:hover > label {
    background-color: hsla(0, 0%, 100%, 0.05);
    opacity: 1;
  }
  .referrals_table_wrapper .yourbids_table_row:hover > label.open.profit {
    background-color: hsla(126, 100%, 38%, 0.15);
  }
  .referrals_table_wrapper .grid-body .grid-header label {
    position: sticky;
    top: 0;
    font-size: 0.8rem;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    white-space: nowrap;
    border-top: 1px solid transparent;
    cursor: pointer;
    color: hsl(0, 0%, 100%, 0.4);
    background: hsla(0, 0%, 0%, 0.2);
    padding: 12px 6px 11px 6px;
    z-index: 1;
    opacity: 1;
  }
  .referrals_table_wrapper .grid-body .grid-content label {
    padding: 16px 6px 15px 6px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
    font-size: 0.9rem;
    text-align: left;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    opacity: 1;
  }
  .referrals_table_wrapper .grid-header label.tier,
  .referrals_table_wrapper .grid-content label.tier {
    padding-left: 30px;
  }
  .referrals_table_wrapper .grid-body.your_bids_iw {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    overflow-y: auto;
    overflow-x: hidden;
    width: 100%;
  }
`

const developerCSS = css``

export const ReferralsCSS = styled.div`
  height: calc(100vh - 70px);
  overflow-y: auto;
  overflow-x: hidden;
  margin-top: 70px;
  ${designerCSS}
  ${developerCSS}
`
